<template>
    <div class="forgot-password">
        <div class="container">
            <div class="content-center">
                <div class="row">
                    <div class="col col-12 d-block d-lg-none">
                        <h2 class="foodsoft-sm"><a href="https://www.foodsoft.org">Foodsoft</a></h2>
                    </div>
                    <div class="col col-lg-6 d-none d-lg-block">
                        <h2 class="foodsoft-lg"><a href="https://www.foodsoft.org">Foodsoft</a></h2>
                        <div class="description">
                            <div v-for="category in categories" :key="category.id" class="category">
                                <draggable v-model="category.products" :group="'group-1'" tag="ul">
                                    <template v-for="item in category.products">
                                        <li v-if="!item.isDeleted" :key="item.id">item {{item.number}}</li>
                                    </template>
                                </draggable>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-lg-5 offset-lg-1">
                        <div class="card-plain">
                            <header>
                                <h1>Forgot Password</h1>
                            </header>
                            <form @submit.prevent="submit">
                                <div class="form-group">
                                    <label for="company-code">{{ $t('company_code') }}</label>
                                    <div class="input-group flex-nowrap">
                                        <input id="company-code" type="text" class="form-control"
                                               :rules="[rules.required]" v-model="authData.companyCode"
                                               :disabled="authCompany && authCompany.code">
                                        <div v-if="authCompany && authCompany.code" class="input-group-append">
                                            <span class="input-group-text" @click="authRemoveCompany">
                                                <font-awesome-icon
                                                        :icon="['fal', 'undo']"/>
                                            </span>
                                        </div>
                                    </div>
                                    <small v-if="false" class="form-text text-muted">this field is required</small>
                                </div>
                                <template v-if="!authCompany || !authCompany.code">
                                    <button type="submit" class="btn btn-primary btn-block">
                                        {{ $t('proceed') }}
                                    </button>
                                </template>
                                <template v-else>
                                    <div class="form-group">
                                        <label for="username">{{ $t('username') }}</label>
                                        <input id="username" autocomplete="username" type="text" class="form-control"
                                               :rules="[rules.required]"
                                               v-model="authData.username">
                                        <small v-if="false" class="form-text text-muted">this field is required</small>
                                    </div>
                                    <div class="form-group input-password">
                                        <label for="password">{{ $t('password') }}</label>
                                        <div class="input-group flex-nowrap">
                                            <input id="password" autocomplete="current-password"
                                                   :type="showPassword ? 'text' : 'password'"
                                                   class="form-control" v-model="authData.password">
                                            <div class="input-group-append">
                                                <span class="input-group-text" @click="showPassword = !showPassword">
                                                    <font-awesome-icon
                                                            :icon="['fal', showPassword ? 'eye-slash' : 'eye']"/>
                                                </span>
                                            </div>
                                        </div>
                                        <small v-if="false" class="form-text text-muted">required</small>
                                    </div>
                                    <button type="submit" class="btn btn-primary btn-block" :disabled="loading"
                                            v-text="!loading ? $t('sign_in') : $t('loading')"></button>
                                    <p class="forgot-password-paragraph">
                                        <router-link to="/auth/forgot-password/">{{ $t('forgot_password') }}
                                        </router-link>
                                    </p>
                                    <i18next path="recaptcha_warning" tag="p" class="recaptcha-warning">
                                        <a :href="$t('privacy_policy_link')" target="_blank" rel="nofollow">{{
                                            $t('privacy_policy') }}</a>
                                        <a :href="$t('terms_of_service_link')" target="_blank" rel="nofollow">{{
                                            $t('terms_of_service') }}</a>
                                    </i18next>
                                </template>
                            </form>
                        </div>
                    </div>
                    <div class="col col-12 d-block d-lg-none">
                        <footer class="footer-sm">
                            <hr>
                            <ul class="list-unstyled">
                                <li><a href="https://foodsoft.org/about-us/" target="_blank">About Us</a></li>
                                <li><a href="https://foodsoft.org/service-terms/" target="_blank">Service Terms</a></li>
                                <li><a href="https://foodsoft.org/privacy-policy/" target="_blank">Privacy Policy</a>
                                </li>
                                <li><a href="https://foodsoft.org/faq/" target="_blank">FAQ</a></li>
                            </ul>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import draggable from 'vuedraggable'

    export default {
        name: "Login",
        i18nOptions: {namespaces: ['auth_login']},
        components: {draggable},
        metaInfo() {
          return {
            title: this.$t('forgot_password')
          }
        },
        data: () => ({
            categories: [
                {
                    id: 1,
                    name: "cat 1",
                    products: [
                        {id: 1, number: 1, isDeleted: false},
                        {id: 2, number: 2, isDeleted: false},
                        {id: 3, number: 3, isDeleted: true},
                        {id: 4, number: 4, isDeleted: false},
                        {id: 5, number: 5, isDeleted: false},
                    ]
                },
                {
                    id: 2,
                    name: "cat 2",
                    products: [
                        {id: 1, number: 1, isDeleted: false},
                        {id: 2, number: 2, isDeleted: false},
                        {id: 3, number: 3, isDeleted: true},
                        {id: 4, number: 4, isDeleted: false},
                        {id: 5, number: 5, isDeleted: false},
                    ]
                }
            ],

            originalBodyBackground: "",
            showPassword: false,
            loading: false,
            rules: {
                required: value => !!value || 'Required',
                min: v => (v && v.length >= 8) || 'Min 8 characters'
            },
            authData: {
                username: "",
                password: "",
                companyCode: ""
            }
        }),
        computed: {
            ...mapGetters(['authCompany', 'authToken'])
        },
        methods: {
            ...mapMutations(['authSetCompany', 'authRemoveCompany']),
            async submit() {
                if (!this.authCompany || !this.authCompany.code) {
                    if (this.authData.companyCode) {
                        this.authSetCompany({company: {code: this.authData.companyCode}});
                    }
                    return;
                }

                try {
                    this.loading = true;
                    await this.$store.dispatch('authLogin', this.authData);
                    await this.$router.push('/');
                } catch (e) {
                    // console.log(e);
                    // console.log('login error: ', e.response.data.status);
                }
                this.loading = false;
            },
        },
        beforeMount() {
            // console.log('before mount forgot-password');
            this.originalBodyBackground = document.body.style.background;
            document.body.style.background = "#f7f7f7";

            if (this.authToken) {
                this.$router.push('/').catch(() => {
                });
            }

        },
        mounted() {
            this.authData.companyCode = this.authCompany && this.authCompany.code;
        },
        destroyed() {
            document.body.style.background = this.originalBodyBackground;
        }
    }
</script>

<style lang="scss" scoped>
    @media (min-width: 1600px) {
        .container {
            max-width: 1500px;
        }
    }

    .login {
        height: 100vh;
        max-height: 1050px;
        padding: 0;
        position: relative;
        background-color: #f7f7f7;
    }

    .login:before {
        /*background-color: #71a3ff;*/
        background-color: #51419d;
        content: '';
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 184px;
        left: 0;
    }

    .content-center {
        position: relative;
        width: 100%;
        max-width: 960px;
        margin: 0 auto;
        z-index: 99;
        padding: 56px 15px 0;

        @media (min-width: 992px) {
            padding: 120px 15px 120px;
        }
    }

    h2.foodsoft-sm {
        font-size: 1.5625rem;
        font-family: $font-display;
        margin: 0;
        padding: 1.5625rem 0 .55rem;
        text-align: center;

        a {
            color: #fff;
            text-decoration: none;
        }
    }

    h2.foodsoft-lg {
        font-size: 1.5625rem;
        font-family: $font-display;
        margin: 0;
        padding: 1.5625rem 0 .55rem;

        a {
            color: #fff;
            text-decoration: none;
        }
    }

    .description {
        padding: 1.4rem 0 1rem;

        h3 {
            font-family: $font-display;
            text-transform: uppercase;
            font-weight: 300;
        }

        p {
            margin-top: 10px;
            font-family: $font-display;
            font-weight: 300;
        }
    }

    footer.footer-lg {
        .social-links {
            a {
                font-size: 1.1rem;
                color: #333;
            }
        }

        ul {
            margin-bottom: .5rem;

            li {
                display: inline-block;
                padding: 0 1.1rem .2rem 0;
                font-family: $font-display;
                font-weight: 300;
                font-size: 0.875rem;
                text-transform: uppercase;

                a {
                    color: #333;
                }
            }
        }

        hr {
            margin: .7rem 0;
        }
    }

    footer.footer-sm {
        margin: 120px auto 0;
        display: table;

        ul {
            text-align: center;
            margin-bottom: .5rem;

            li {
                display: inline-block;
                padding: 0 0.55rem .2rem 0.55rem;
                font-family: $font-display;
                font-weight: 300;
                font-size: 0.875rem;
                text-transform: uppercase;

                a {
                    color: #333;
                }
            }
        }

        hr {
            margin: .7rem 0;
        }
    }

    .card-plain {
        margin: 0 auto;
        border-radius: 9px;
        max-width: 330px;
        padding: 20px;
        background: #fff;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);

        h1 {
            font-size: 1.5rem;
            line-height: 1.4em;
            margin-bottom: 20px;
            font-family: $font-display;
            text-align: center;
        }

        label {
            font-family: $font-display;
            font-weight: 300;
        }

        .form-text {
            /*font-family: Poppins, sans-serif;*/
            /*font-weight: 300;*/
        }

        .input-password .input-group-text {
            width: 2.875rem;

            svg {
                margin: 0 auto;
            }
        }

        .btn-primary {
            margin-top: 2rem;
        }

        .forgot-password-paragraph {
            margin: 10px 0 0;
            text-align: center;
            font-size: 0.875rem;
        }

        .recaptcha-warning {
            margin: 20px 0 0;
            padding-top: 5px;
            border-top: 1px solid #e8e8e8;
            font-size: 0.75rem;
            color: #bbb;

            a {
                color: #bbb;
            }
        }
    }
</style>
